<template>
  <div class="">
    <div class="cash-wrap">
      <div class="cash-item">
        <div class="cash-name">账户余额</div>
        <div class="cash-value">¥{{ info.bonus || 0}}</div>
      </div>
      <div class="cash-item">
        <div class="cash-name">累计收益</div>
        <div class="cash-value">¥{{ info.bonus_total || 0}}</div>
      </div>
      <div class="cash-item">
        <div class="cash-name">今日收益</div>
        <div class="cash-value">
          ¥{{ cashInfo.todayIncome || 0 }}
        </div>
      </div>
    </div>
    <el-form :inline="true">
      <!-- <el-form-item label="收益类型">
        <el-select v-model="type" placeholder="选择收益类型" clearable>
          <el-option label="课程结算" :value="5"></el-option>
          <el-option label="邀请收益" :value="3"></el-option>
          <el-option label="支出/提现" :value="4"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
     <template #status="{ row }">
        <div>
          <el-tag type="success" size="small" v-if="row.status === 1"
            >已到账</el-tag
          >
          <el-tag type="info" size="small" v-if="row.status === 2"
            >未到账</el-tag
          >
          <el-tag type="warning" size="small" v-if="row.status === 4"
            >已退款</el-tag
          >
        </div>
      </template>
    </auto-table>
  </div>
</template>

<script>
export default {
    props:{
        info:{
            type:Object,
            default:()=>{return {}}
        }
    },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "说明", value: "remark" },
        { name: "金额(元)", value: "cash" },
         { name: "状态", value: "status" ,type:'custom'},
        { name: "时间", value: "create_time" },
         { name: "到账时间", value: "account_day" },
      ],
      Total: 0,
      type: "",
      id: "",
      init: false,
      cashInfo: {},
    };
  },

  mounted() {
    this.id = this.$route.query.id;
  },

  methods: {
    load() {
      if (!this.init) {
        this.init = true;
        this.getList(1);
        this.getEnrollCash();
      }
    },
    userDetail(row) {
      this.$router.push({ name: "userDetails", params: { id: row.user_id } });
    },
    getEnrollCash() {
      this.$axios({
        url: "/user/adminBonusLog/todayIncome",
        params: {
          admin_id: this.id,
        },
      }).then((res) => {
        this.cashInfo = res.data.data;
      });
    },
    //分成记录
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/adminBonusLog/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          admin_id: this.id,
          types: this.type || '1,3,4',
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cash-wrap {
  display: flex;
  margin-bottom: 10px;
}
.cash-item {
  padding: 10px 20px;
  margin-right: 20px;
  background-color: rgba(243, 202, 140, 0.7);
  border-radius: 10px;
  min-width: 100px;
}
.cash-name {
  font-size: 14px;
}
.cash-value {
  font-size: 20px;
  margin-top: 10px;
}
</style>